<template>
    <CCard
        v-if="data.page"
        :isLoading="isLoading"
        v-model:page="data.page"
        :options="data.tableOptions"
        :manageExtras="data.manageExtras"
        :clientSide="true"
        :canRefresh="false"
        :visibleSearch="false"
        :visiblePagination="false"
        :colProp="{class: 'border-0'}"
    >
    </CCard>
    <div v-for="record in data.page.data" :key="rowKey(record)">
        <Row align="middle" justify="center">
            <Col :xs="24">
                <Card class="m-2 cursor-pointer card-item" @click="() => 'fishingToolRequests'.includes(props.itemsKey) && !props.viewOnly && conditionListPageFishingTool({ data }) ? onClickEdit({ record, props, data }) : null" :style="record.color">
                    <Row>
                        <Col :xs="24" :md="20">
                            {{ $t("model.fishingToolRequest.refFishingToolType") }}: {{ record.refFishingToolType?.nameTh }} <br />
                            {{ $t("model.fishingToolRequest.refFishingTool") }}: {{ record.refFishingTool?.nameTh }} <br />
                            {{ $t("model.fishingToolRequest.qty") }}: {{ record.qty }} {{ record.refUnitType?.value }}<br />
                            <span v-if="record.refFishingTool.isRequireInputWidth == true">{{ $t("model.fishingToolRequest.width") }}: {{ record.width }}  {{ record.refWidthType?.value }}<br/></span>
                        </Col>
                        <!-- <Col :xs="24" :md="4" class="text-center">
                            <Button style="background-color: red"
                                    @click="(e) => {e.stopPropagation(); return 'fishingToolRequests'.includes(props.itemsKey) && !props.viewOnly ? onClickDelete({ record, props, data }) : null }"
                                    v-if="['fishingToolRequests'].includes(props.itemsKey) && !props.viewOnly && conditionListPageFishingTool({ data })">
                                <CIcon file="delete.svg" style="color: white"
                                ></CIcon>
                            </Button>
                        </Col> -->
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
    <div class="has-error" v-if="data.useForm?.validateInfos?.[itemsKey]?.validateStatus === 'error'">
        <div class="ant-form-explain">
            {{ data.useForm?.validateInfos?.[itemsKey]?.help }}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent, defineComponent, reactive, watch } from "vue";
import { Card, Row, Col/*, Button*/ } from "ant-design-vue";
import { state as stateApp } from "../../../../../../app.logic";
import { initData, isLoading, onClickEdit/*, onClickDelete*/, conditionListPageFishingTool } from "./fishing-tool.logic";
import { rowKey } from "../../../../../../components/table/c-table.logic";

export default defineComponent({
    components: {
        //Button,
        Card,
        Row,
        Col,
        CCard: defineAsyncComponent(() => import("../../../../../../components/card/CCard")),
        //CIcon: defineAsyncComponent(() => import("../../../../../../components/icon/CIcon")),

    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: { default: false },
        rowKey: { default: () => rowKey },
        dataProp: {},
        itemsKey: { default: "fishingToolRequests" },
        visible: { default: true },
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({});
        initData({ props, data, refs });
        watch(
            () => data.useForm?.modelRef?.licenseCode,
            () => initData({ props, data, refs }),
            { flush: "post" }
        );
        return { props, data, refs, isLoading, onClickEdit/*, onClickDelete*/, conditionListPageFishingTool };
    },
});
</script>
